<app-spinner-overlay [showSpinner]="showSpinner"></app-spinner-overlay>

<wl-card heading="{{profileName}} {{custProfile}}">
  <!-- <button (click)="consoleIt()" style="position:absolute; top:0;right: 0;opacity: 0; height:50px">Test</button> -->
  <div class="container" style="min-height: 130vh;" *ngIf="showAddCustomer && projectName !=='kgb'">


    <!-- loan account form below -->

    <form [formGroup]="loanForm" #formGroupDirective="ngForm">
      <!-- Application type -->


      <div class="row" style="margin-top: 18px" *ngIf="isPanRequired">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Choose Profile Type -->
              Enter PAN
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width:100%;" appearance="outline">
            <mat-label>Enter PAN Number
            </mat-label>
            <input type="text" matInput placeholder="Enter PAN Number *" formControlName="panNo" maxlength="10"
              minlength="10" [readonly]="isPanAllowed" autocomplete="off"
              (keyup)="loanForm.patchValue({panNo: $event.target.value.toUpperCase()})">
            <!-- <mat-error >
            Name should contain only Alphabets
          </mat-error> -->
          </mat-form-field>


          <!-- <mat-icon *ngIf="isOfficeVerified" style="color:#05d016">check_circle</mat-icon> -->
        </div>


        <div class="col-md-3 col-sm-12" style="padding: 7px;font-size: medium;">
          <button class="mybutton" type="button" *ngIf="!isPanVerified" (click)="checkPAN(loanForm.value)"
            [disabled]="loanForm.controls['panNo'].invalid || disableValidation"
            style="margin-left: 8px">Search</button>
          <span *ngIf="!isPanAllowed && isPanVerified">
            <mat-icon [style.color]="projectName === 'sahyadarifarms' ? '#005777' : '#05d016'">check_circle</mat-icon>
            New Customer </span>
          <span *ngIf="isPanAllowed && isPanVerified">
            <mat-icon [style.color]="projectName === 'sahyadarifarms' ? '#005777' : '#05d016'">check_circle</mat-icon>
            Existing Customer </span>
        </div>
      </div>


      <div class="row">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Choose Profile Type -->
              Type of {{custProfile}}
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Select {{custProfile}} Type</mat-label>
            <mat-select placeholder="Select {{custProfile}} Type *" formControlName="customerTypes" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onNonIndividualTypeChange($event)"
              class="ng-untouched ng-pristine">
              <mat-option *ngFor="let indivORNonIndiv of indivORNonIndiv" [value]="indivORNonIndiv.type">{{
                indivORNonIndiv.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <div class="row" *ngIf="isNonIndiviShown">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              {{custProfile}} Type
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{custProfile}} Type *</mat-label>
            <mat-select placeholder="{{custProfile}} Type *" formControlName="entityType" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onNonIndividualTypeChange($event)">
              <mat-option *ngFor="let nonIndivType of selectedNonIndivType" [value]="nonIndivType.type">{{
                nonIndivType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <div class="row" *ngIf="!isNonIndiviShown">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              {{custProfile}} Type
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>{{custProfile}} Type </mat-label>
            <mat-select placeholder="{{custProfile}} Type*" formControlName="loanCustType" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onCustTypeChange($event)">
              <mat-option *ngFor="let customerType of profileType" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="projectName === 'sahyadarifarms' && typeOfCustomer === 'Farmer Agri'">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              FPO Name
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>FPO Name</mat-label>
            <mat-select placeholder="FPO Name*" formControlName="fpoName" style="width: 100%;" appearance="outline">
              <mat-option *ngFor="let branch of fpoBranches" [value]="branch.id">{{ branch.branchName }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>




      <div class="row" *ngIf="apcobProject && isotherType">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              Others Type
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter the type of the customer </mat-label>
            <input type="text" matInput placeholder="Enter the type of the customer" formControlName="othersType"
              autocomplete="off" (change)="onOthersTypeChange($event.target.value)"
              onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode === 32"
              [readonly]="disableValidation">

          </mat-form-field>
        </div>
      </div>





      <div class="row" *ngIf="apcobProject">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Loan Type
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <!-- <mat-label>Select Loan type</mat-label> -->
            <mat-select placeholder="Select Loan type" formControlName="loanType" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onLoanType($event)">
              <mat-option *ngFor="let customerType of apcobLoanType" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <div class="row" *ngIf="apcobProject && subLoanTypeRequired">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Sub Loan Type
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Select Sub Loan type</mat-label>
            <mat-select placeholder="Select Sub Loan type" formControlName="loanSubType" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onSubLoanType($event)">
              <mat-option *ngFor="let customerType of subLoanType" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      

      <div class="row" *ngIf="apcobProject && traderLoan &&  ssuf">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              Sub {{apcobSubLoanType}} Loan Type
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Select Sub {{apcobSubLoanType}} Loan type</mat-label>
            <mat-select placeholder="Select Sub {{apcobSubLoanType}} Loan type" formControlName="traderLoanSub"
              style="width: 100%;" appearance="outline" [disabled]="disableValidation"
              (selectionChange)="onTraderLoan($event)">
              <mat-option *ngFor="let customerType of subTraderLoanType" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

       <div class="row" *ngIf="apcobProject && mortgageLoan">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              Collateral Security
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Collateral Security</mat-label>
            <mat-select placeholder="Select Collateral Security" formControlName="collateralSecurity"
              style="width: 100%;" appearance="outline" [disabled]="disableValidation"
              (selectionChange)="onCollateralSecurity($event)">
              <mat-option *ngFor="let customerType of mlSubLoanType" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

       <div class="row" *ngIf="apcobProject && mortgageLoan">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              Age of Property
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter Age of Property </mat-label>
            <input type="number" matInput placeholder="Enter Age of Property"
              formControlName="ageOfProperty" autocomplete="off" min="0" max="90">
            <mat-error>
              Please enter a valid Age of Property
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="apcobProject">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Are You an Existing Customer
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Existing Customer? </mat-label>
            <mat-select placeholder="Existing Customer?" formControlName="existingCust" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onCustExisting($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="apcobProject && existAcc">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              Account Number
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter the Bank Account Number </mat-label>
            <input type="text" matInput placeholder="Enter the bank account number" formControlName="accountNumber"
              autocomplete="off"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="disableValidation">

          </mat-form-field>
        </div>
      </div>



      <div class="row" *ngIf="existAcc && apcobProject">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Do you have Account more than 6 months
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Existing Account holder? </mat-label>
            <mat-select placeholder="Existing Account holder?" formControlName="existingAcc" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onAccountExisting($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <div class="row" *ngIf="apcobProject">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Are you an APCOB staff
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>APCOB staff </mat-label>
            <mat-select placeholder="Existing staff of APCOB?" formControlName="existingStaff" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onExistingStaff($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="apcobProject && personalLoan">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Do you have Salary Account with APCOB
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Salary Account with APCOB? </mat-label>
            <mat-select placeholder="Salary Account with APCOB?" formControlName="salaryAccount" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onSalaryAccount($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <div class="row" *ngIf="!existAcc && apcobProject">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              Working in a Govt or Reputed Private Institutions
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Working in govt or pvt ? </mat-label>
            <mat-select placeholder="Working in govt or pvt ?" formControlName="workAcc" style="width: 100%;"
              appearance="outline" (selectionChange)="onWorkAccountExisting($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="apcobProject && existingApcobStaff == false && selectedApcobLoanType !== 'Gold Loan'">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Do you have Mortgage Loan with APCOB?
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Do you have Mortgage Loan with APCOB?</mat-label>
            <mat-select placeholder="Do you have Mortgage Loan with APCOB?" formControlName="mortLoan" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onMortgageLoanChange($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

       <div class="row" *ngIf="apcobProject && existingApcobStaff == false && mortgageLoanChange">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Do you have Margin Amount?
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label> Do you have Margin Amount?</mat-label>
            <mat-select placeholder="Do you have Margin Amount?" formControlName="marAmount" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onMarginAmountChange($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="apcobProject && selectedApcobLoanType !== 'Gold Loan'">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              ITR Filled
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>ITR Filled? </mat-label>
            <mat-select placeholder="ITR Filled?" formControlName="itrFilled" style="width: 100%;" appearance="outline"
              [disabled]="disableValidation" (selectionChange)="onITRFilled($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>



      <div class="row" *ngIf="apcobProject">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              Age
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter age of the customer </mat-label>
            <input type="text" matInput placeholder="Enter age of the customer" formControlName="age" autocomplete="off"
              (change)="onAgeChange($event.target.value)"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="disableValidation">
            <mat-error>
              {{ageErrorMessage}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>




      <div class="row" *ngIf="apcobProject">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              Loan Amount
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Loan Amount </mat-label>
            <input type="text" matInput placeholder="Enter Loan Amount" formControlName="loanAmount"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="disableValidation" autocomplete="off">
            <mat-error>
              {{loanAmountErrorMessage}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>



      <div class="row" *ngIf="apcobProject">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              Tenure(in Months)
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Tenure</mat-label>
            <input type="text" matInput placeholder="Enter Tenure(in Months)" formControlName="tenure"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="disableValidation" autocomplete="off">
            <mat-error>
              {{loanTenureErrMessage}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="apcobProject && selectedApcobLoanType !== 'Gold Loan'">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              Security Property Distance(in Kms)
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter Distance</mat-label>
            <input type="text" matInput placeholder="Enter distance" formControlName="propertyDist"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="disableValidation" autocomplete="off">
            <mat-error>
              {{distanceErrMessage}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>





      <div class="row" *ngIf="apcobProject && personalLoan">
        <div class="col-md-3 col-sm-12" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 0px">
              <!-- Select Type Of Profile -->
              Guarantor with Permanent/confirmed employment in Government/private institutions
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Valid Guarantor? </mat-label>
            <mat-select placeholder="Valid Guarantor?" formControlName="guarantor" style="width: 100%;"
              appearance="outline" [disabled]="disableValidation" (selectionChange)="onGuarantor($event)">
              <mat-option *ngFor="let customerType of yesorNo" [value]="customerType.type">{{
                customerType.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <div class="row">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              {{custProfile}} Name
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter {{custProfile}} Name(As per Photo ID) </mat-label>
            <input type="text" matInput placeholder="Enter {{custProfile}} Name *" formControlName="loanCustName"
              [readonly]="disableValidation" autocomplete="off"
              onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || event.charCode === 32">
            <mat-error>
              Name should contain only Alphabets
            </mat-error>
          </mat-form-field>
        </div>
      </div>


      <div class="row">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              {{custProfile}} Mobile Number
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter {{custProfile}} Mobile Number *</mat-label>
            <input type="text" matInput placeholder="Enter {{custProfile}} Mobile Number *"
              formControlName="loanCustMobNum" minlength=10 maxlength=10
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              [readonly]="disableValidation" autocomplete="off">
            <mat-error>
              Please enter a valid Mobile Number
            </mat-error>
          </mat-form-field>
        </div>
      </div>


      <div class="row" *ngIf="!apcobProject">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              {{custProfile}} Email
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">


          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter Personal Mail ID </mat-label>
            <input type="email" matInput placeholder="Enter {{custProfile}} / Business Mail ID *"
              formControlName="loanCustEmail" autocomplete="off">
            <mat-error>
              Please enter a valid Email ID
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-md-3" style="padding: 0px !important; margin-top: 7px">
          <div>
            <p style="text-align: left; padding-left: 20px; margin-top: 11px">
              {{custProfile}} Mobile Number
            </p>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" style="padding: 0px">

          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Enter {{custProfile}} Mobile Number *</mat-label>
            <input type="text" matInput placeholder="Enter {{custProfile}} Mobile Number *"
              formControlName="loanCustMobNum" minlength=10 maxlength=10
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
              autocomplete="off">
            <mat-error>
              Please enter a valid Mobile Number
            </mat-error>
          </mat-form-field>
        </div>
      </div> -->

      <div class="row" fxLayout="row" fxLayoutAlign="start center" fxFlex.xs="00">
        <div class="col-md-3"></div>
        <div class="col-md-6" style="text-align:center">
          <button color="primary" style="margin: auto; color: white" md-button class="mybutton" type="submit"
            fxFlex.xs="200"
            [disabled]="( loanForm.controls['loanCustMobNum'].invalid || loanForm.invalid || disableSubmit || isDisableSubmit) "
            (click)="onLoanFormSubmit()">
            Submit
          </button>
        </div>
      </div>

      <br>

    </form>


  </div>

  <div class="container" *ngIf="showExistingCustomerName && projectName !== 'kgb'" style="height: 10rem;">
    <wl-card heading="Customer Found">
      <div>
        <div class="row">

          <div class="col-2">
            <span style="font-size: 2 rem; font-weight: bold;"> Customer name : </span>
          </div>
          <div class="col-4">
            <span style="font-size: 2 rem; font-weight: bold;"> {{customerName}} </span>
          </div>
          <div class="row">

            <div class="col-2">
              <span style="font-size: 2 rem; font-weight: bold;"> Customer ID : </span>
            </div>
            <div class="col-4">
              <span style="font-size: 2 rem; font-weight: bold;"> {{profileId}} </span>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              Please go to View customers and proceed to Validate.
            </div>
          </div>
        </div>
      </div>
    </wl-card>
  </div>

  <div [formGroup]="loanForms" class="kgb-form-container" *ngIf="projectName === 'kgb'">

    <div fxLayout="column" fxLayoutGap="10px" style="padding: 20px;">

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Customer ID</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input matInput type="text" placeholder="Customer ID" formControlName="profileId">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Enter Customer Name</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input matInput type="text" placeholder="Enter Customer Name(As Per Photo ID)" formControlName="name"
            autocomplete="off">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Enter Customer Email</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input matInput type="email" placeholder="Enter Customer Email" formControlName="email" autocomplete="off">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Enter Customer Mobile Number</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input type="tel" placeholder="Enter Customer Mobile Number" matInput formControlName="mobileNo"
            maxlength="10">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Address</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input matInput type="text" placeholder="Residence Unit No, Building Name, Property No (as applicable)"
            formControlName="resAdd" autocomplete="off">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Residence Address</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input matInput type="text" placeholder="Residence Address" formControlName="resAdd" autocomplete="off">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Office Address</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input matInput type="text" placeholder="Office - Unit No, Building Name, Property No (as applicable)"
            formControlName="offadd" autocomplete="off">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row">
        <label fxFlex="35" class="kgb-label">Office Address</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <input matInput type="text" placeholder="Office Address" formControlName="office" autocomplete="off">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row" style="margin-top: 20px;">
        <label fxFlex="35" class="kgb-label">Application Type</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <mat-select placeholder="Select Type Of Application" formControlName="applicationType"
            (selectionChange)="onApplicationTypeChange($event)" panelClass="kgb-custom-select-panel">
            <mat-option *ngFor="let type of application_type" [value]="type.name">{{ type.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" class="form-row" *ngIf="subLoanOptions.length > 0">
        <label fxFlex="35" class="kgb-label">Loan Category</label>
        <mat-form-field fxFlex="65" appearance="outline" class="kgb-input">
          <mat-select placeholder="Select Loan Category" formControlName="loanType">
            <mat-option *ngFor="let sub of subLoanOptions" [value]="sub.name">{{ sub.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="button-wrapper">
        <button class="kgb-submit-btn" (click)="onLoanFormSubmit()">Add Applicant</button>
      </div>

    </div>
  </div>

</wl-card>


<!-- <div class="container" style="min-height: 13vh;
    position: fixed;
    top: 20vh;
    z-index: 9999;
    background-color: aqua">
  <form action="https://pay.whatsloan.com/v1/paymentGateway/verifyPaymentInfoCallBack" method="POST">
    <script
       src="https://checkout.razorpay.com/v1/checkout.js"
        data-key="rzp_test_fbWcQYzGIGylZr" 
        data-amount="29935" 
        data-currency="INR"
        data-order_id="{{orderId}}"
        data-buttontext="Pay with Razorpay"
        data-name="data name is here"
        data-description="Frontend king"
        data-image="https://example.com/your_logo.jpg"
        data-prefill.name="Whatsloan"
        data-prefill.email="dmdmdmdm"
        data-theme.color="#F37254">
      </script>
    <input type="hidden" custom="Hidden Element" name="hidden"/>
    </form>
  </div> -->